import QueryStatsIcon from '@mui/icons-material/QueryStats';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import SupervisorAccount from '@mui/icons-material/SupervisorAccount';
import GroupIcon from '@mui/icons-material/Group';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import EventIcon from '@mui/icons-material/Event';
import PaymentIcon from '@mui/icons-material/Payment';
import ConnectWithoutContact from '@mui/icons-material/ConnectWithoutContact';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import PaymentsIcon from '@mui/icons-material/Payments';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import SettingsIcon from '@mui/icons-material/Settings';
import PublicIcon from '@mui/icons-material/Public';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CodeIcon from '@mui/icons-material/Code';
import ReceiptIcon from '@mui/icons-material/Receipt';
import FileCopyIcon from '@mui/icons-material/FileCopy';

export const menuConfig = [
    {
        title: 'menu.dashboard',
        path: '/app/dashboard',
        icon: <QueryStatsIcon />
    },
    {
        title: 'pages.account.title',
        path: '/app/users',
        icon: <AccountBoxIcon />,
        sublistData: [
            {
                title: 'pages.users.title',
                icon: <SupervisorAccount />,
                controller: 'users',
                path: '/app/users'
            },
            {
                title: 'pages.roles.title',
                icon: <GroupIcon />,
                controller: 'roles',
                path: '/app/roles'
            },
            {
                title: 'pages.rolePermissions.title',
                icon: <WorkspacesIcon />,
                controller: 'role-permissions',
                path: '/app/role-permissions'
            },
            {
                title: 'pages.rolesActionsPermissions.title',
                icon: <DisplaySettingsIcon />,
                controller: 'roles-actions-permissions',
                path: '/app/roles-actions-permissions'
            }
        ]
    },
    {
        title: 'pages.events.title',
        icon: <EventIcon />,
        sublistData: [
            {
                title: 'pages.paymentEvents.title',
                icon: <PaymentIcon />,
                controller: 'payment-events',
                path: '/app/payment-events'
            },
            {
                title: 'pages.payoutEvents.title',
                icon: <QueryStatsIcon />,
                controller: 'payout-events',
                path: '/app/payout-events'
            },
            {
                title: 'pages.p2pEvents.title',
                icon: <ConnectWithoutContact />,
                controller: 'p2p-events',
                path: '/app/p2p-events'
            },
            {
                title: 'pages.urlCallbacks.title',
                icon: <RequestPageIcon />,
                controller: 'url-callbacks',
                path: '/app/url-callbacks'
            }
        ]
    },
    {
        title: 'pages.payment.title',
        icon: <AccountBalanceWalletIcon />,
        sublistData: [
            {
                title: 'pages.paymentInstances.title',
                icon: <BusinessCenterIcon />,
                controller: 'payment-instances',
                path: '/app/payment-instances'
            },
            {
                title: 'pages.p2pInstances.title',
                icon: <ConnectWithoutContact />,
                controller: 'p2p-instances',
                path: '/app/p2p-instances'
            },
            {
                title: 'pages.paymentRefunds.title',
                icon: <AssignmentTurnedInIcon />,
                controller: 'payment-refunds',
                path: '/app/payment-refunds'
            },
            {
                title: 'pages.paymentOrders.title',
                icon: <PaymentsIcon />,
                controller: 'payment-orders',
                path: '/app/payment-orders'
            },
            {
                title: 'pages.cryptoPayments.title',
                icon: <PaymentsIcon />,
                controller: 'crypto-payments',
                path: '/app/crypto-payments'
            },
            {
                title: 'pages.publicChargebacks.title',
                icon: <CurrencyExchangeIcon />,
                controller: 'public-chargebacks',
                path: '/app/chargebacks'
            },
            {
                title: 'pages.publicFrauds.title',
                icon: <CurrencyExchangeIcon />,
                controller: 'public-frauds',
                path: '/app/fraud'
            },
            {
                title: 'pages.publicAppeals.title',
                icon: <CurrencyExchangeIcon />,
                controller: 'public-appeals',
                path: '/app/appeals'
            }
        ]
    },
    {
        title: 'pages.payout.title',
        icon: <PaymentsIcon />,
        sublistData: [
            {
                title: 'pages.payoutInstances.title',
                icon: <BusinessCenterIcon />,
                controller: 'payout-instances',
                path: '/app/payout-instances'
            },
            {
                title: 'pages.payoutOrders.title',
                icon: <RequestQuoteIcon />,
                controller: 'payout-orders',
                path: '/app/payout-orders'
            }
        ]
    },
    {
        title: 'pages.merchantServices.title',
        icon: <BusinessCenterIcon />,
        sublistData: [
            {
                title: 'pages.publicMerchants.title',
                icon: <CardMembershipIcon />,
                controller: 'public-merchants',
                path: '/app/merchants'
            },
            {
                title: 'pages.publicMerchantTerminals.title',
                icon: <AttachMoneyIcon />,
                controller: 'public-merchant-terminals',
                path: '/app/merchant-terminals'
            },
            {
                title: 'pages.publicMerchantTerminalPayoutRequests.title',
                icon: <RequestPageIcon />,
                controller: 'public-merchant-terminal-payout-requests',
                path: '/app/public-merchant-terminal-payout-requests'
            },
            {
                title: 'pages.publicMerchantTerminalGateways.title',
                icon: <DeviceHubIcon />,
                controller: 'public-merchant-terminal-gateways',
                path: '/app/merchant-terminal-gateways'
            }
        ]
    },
    {
        title: 'pages.gateways.title',
        icon: <DeviceHubIcon />,
        sublistData: [
            {
                title: 'pages.publicGateways.title',
                icon: <DeviceHubIcon />,
                controller: 'public-gateways',
                path: '/app/gateways'
            },
            {
                title: 'pages.publicTerminalShopWindows.title',
                icon: <BusinessCenterIcon />,
                controller: 'public-terminal-shop-windows',
                path: '/app/terminal-shop-windows'
            },
            {
                title: 'pages.publicGatewayApis.title',
                icon: <DeviceHubIcon />,
                controller: 'public-gateway-apis',
                path: '/app/gateway-apis'
            },
            {
                title: 'pages.publicGatewaySettings.title',
                icon: <SettingsIcon />,
                controller: 'public-gateway-settings',
                path: '/app/gateway-settings'
            },
            {
                title: 'pages.publicGatewayTemplates.title',
                icon: <SettingsIcon />,
                controller: 'public-gateway-templates',
                path: '/app/gateway-templates'
            },

        ]
    },
    {
        title: 'pages.settings.title',
        icon: <SettingsIcon />,
        sublistData: [
            {
                title: 'pages.publicCommissionTypes.title',
                icon: <RequestQuoteIcon />,
                controller: 'public-commission-types',
                path: '/app/commission-types'
            },
            {
                title: 'pages.publicCommissions.title',
                icon: <RequestQuoteIcon />,
                controller: 'public-commissions',
                path: '/app/commissions'
            },
            {
                title: 'pages.cryptoCoins.title',
                icon: <RequestQuoteIcon />,
                controller: 'crypto-coins',
                path: '/app/crypto-coins'
            },
            {
                title: 'pages.publicCurrencyConversionRates.title',
                icon: <CurrencyExchangeIcon />,
                controller: 'public-currency-conversion-rates',
                path: '/app/currency-conversion-rate'
            },
            {
                title: 'pages.publicCountries.title',
                icon: <PublicIcon />,
                controller: 'public-countries',
                path: '/app/countries'
            },
            {
                title: 'pages.filtersBins.title',
                icon: <CreditCardIcon />,
                controller: 'filters-bins',
                path: '/app/filters-bins'
            },
            {
                title: 'pages.publicCascadeRules.title',
                icon: <CodeIcon />,
                controller: 'public-cascade-rules',
                path: '/app/cascade-rules'
            },
            {
                title: 'pages.exportCsvTasks.title',
                icon: <FileCopyIcon />,
                controller: 'public-export-csv-task',
                path: '/app/export-csv-tasks'
            }
        ]
    },
    {
        title: 'pages.accounting.title',
        icon: <ReceiptIcon />,
        sublistData: [
            {
                title: 'pages.accountingSystemAccounts.title',
                icon: <AccountBalanceWalletIcon />,
                controller: 'accounting-system-accounts',
                path: '/app/system-accounts'
            },
            {
                title: 'pages.accountingSystemTransactions.title',
                icon: <RequestQuoteIcon />,
                path: '/app/system-transactions',
                controller: 'accounting-system-transactions'
            },
            {
                title: 'pages.accountingExternalTransactions.title',
                icon: <RequestQuoteIcon />,
                path: '/app/external-transactions',
                controller: 'accounting-external-transactions'
            },
            {
                path: '/app/accounting-gateway-transactions',
                title: 'pages.accountingGatewayTransactions.title',
                icon: <RequestQuoteIcon />,
                controller: 'accounting-gateway-transactions'
            },
            {
                title: 'pages.accountingWithdrawalTransactions.title',
                icon: <RequestQuoteIcon />,
                controller: 'accounting-withdrawal-transactions',
                path: '/app/withdrawal-transactions'
            },
            {
                path: '/app/accounting-gateway-accounts',
                title: 'pages.accountingGatewayAccounts.title',
                icon: <AccountBalanceWalletIcon />,
                controller: 'accounting-gateway-accounts',
            },
            {
                title: 'pages.publicAgents.title',
                icon: <BusinessCenterIcon />,
                controller: 'public-agents',
                path: '/app/agents'
            },
            {
                title: 'pages.accountingAgentTransactions.title',
                icon: <PaymentsIcon />,
                controller: 'accounting-agent-transactions',
                path: '/app/agent-transactions'
            },
            {
                title: 'pages.accountingValidationTasks.title',
                icon: <CodeIcon />,
                controller: 'accounting-validation-tasks',
                path: '/app/accounting-validation-tasks'
            }
        ]
    },
    {
        title: 'pages.publicProviders.title',
        icon: <BusinessCenterIcon />,
        controller: 'public-providers',
        path: '/app/providers'
    }
];
